"use client";

import React from "react";
import { StarRating } from "@audacia-hq/shared/components";
import { useTranslation } from "react-i18next";

import { RatingSummary } from "../../models/ratings";
import { Expert } from "../../models/expert";

interface Props {
  ratingsSummary: RatingSummary[];
  onClick: (rate: number) => void;
  currentRate: number;
  total: string;
  expert?: Expert;
}

const RatingsFilter: React.FC<Props> = ({
  ratingsSummary, onClick, currentRate, total, expert,
}) => {
  const { t } = useTranslation("common");

  return (
    <>
      <span className={`text-black ${expert ? "text-3xl" : "font-semibold text-xl"}`}>{t("reviewsCTA", { total })}</span>
      <div className={`flex flex-col rounded-xl border border-[#D2D2D2] p-6 gap-5 w-full ${expert ? "lg:w-1/2" : ""}`}>
        <span>{t("filterByRating")}</span>
        <div className="flex flex-col gap-2">
          {[...ratingsSummary].map((rs) => (
            <div className="flex gap-3 items-center" key={`rate-sumary-${rs.rate}`}>
              <button
                type="button"
                disabled={rs.count === 0}
                onClick={() => onClick(rs.rate)}
                className="flex gap-2 items-center disabled:opacity-30"
              >
                <input
                  disabled={rs.count === 0}
                  className="h-4 w-4 cursor-pointer disabled:cursor-default"
                  type="radio"
                  value={rs.rate}
                  checked={currentRate === rs.rate}
                  readOnly
                />
                <span className="w-3 font-normal text-base text-black text-center">{rs.rate}</span>
              </button>

              <StarRating
                value={rs.rate}
                max={5}
                disabled
                variant="yellow"
              />
              {expert && (
                <span className="font-normal text-base text-black text-end min-w-16">{`${rs.count} ${t("rating")}`}</span>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default RatingsFilter;
